// StatementDocument.tsx
import React from 'react';
import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';
import { IClient, IUserDetails } from '../../factory/interfaces';

export interface Transaction {
  date_of_creation: string,
  narration: string,
  count: number;
  credit: number;
  debit: number;
  correct_current_balance: number;
  isTotalRow?: boolean;
}

interface StatementDocumentProps {
  transactions: any;
  summary: any,
  agent: IUserDetails | null,
  client: IClient
}

const styles = StyleSheet.create({
  page: { padding: 20, marginBottom: 50 },
  header: { fontSize: 18, fontWeight: 'bold', marginBottom: 15, margin: '10 auto' },
  table: { width: '80%', margin: '20 auto 30 auto'},
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#002542',
    borderBottomStyle: 'solid',
    alignItems: 'center',
    height: 18,
  },
  columnHeaders: {fontWeight: 'bold', backgroundColor: '#cdcdcd', margin: '0 auto', padding: '3 0', textTransform: 'uppercase'},
  subHeader: {fontSize: 8, margin: '3 auto', textTransform: 'uppercase'},
  footer: { width: '80%', margin: '20 auto 10 auto'},
  footerContent: {fontSize: 8, margin: '6', textTransform: 'uppercase', textAlign: 'left'},
  tableCell: { flex: 1, padding: 2, fontSize: 8, textAlign: 'left' },
  doubleWidthCell: { flex: 2, padding: 2, fontSize: 8, textAlign: 'left' },
  totalRow: { fontWeight: 'bold' },
})

const PDFViewer: React.FC<StatementDocumentProps> = ({ transactions, summary, agent, client }) => (
  <Document>
    <Page style={styles.page}>
      <Text style={styles.header}>FINANCIAL STATEMENT</Text>
      <Text style={styles.subHeader}>Client: {client.surname} {client.given_name} </Text>
      <Text style={styles.subHeader}>Branch: {client.branch.toLocaleUpperCase()} </Text>
      <Text style={styles.subHeader}>As of: {new Date().toLocaleString()} </Text>

      <View style={styles.table}>
        {/* Table Headers */}
        <View style={styles.tableRow}>
          <Text style={[styles.tableCell, styles.columnHeaders]}>#</Text>
          <Text style={[styles.doubleWidthCell, styles.columnHeaders]}>Date & Time</Text>
          <Text style={[styles.doubleWidthCell, styles.columnHeaders]}>Narration</Text>
          <Text style={[styles.tableCell, styles.columnHeaders]}>Credit</Text>
          <Text style={[styles.tableCell, styles.columnHeaders]}>Debit</Text>
          <Text style={[styles.tableCell, styles.columnHeaders]}>Balance</Text>
        </View>
        {/* Table Data */}
        {transactions.map((transaction: any, index: any) => (
          <View key={index} style={styles.tableRow}>
            <Text style={styles.tableCell}>{index + 1}</Text> 
            <Text style={styles.doubleWidthCell}>{transaction.date_of_creation}</Text>
            <Text style={styles.doubleWidthCell}>{transaction.narration}</Text>
            <Text style={styles.tableCell}>{transaction.credit}</Text>
            <Text style={styles.tableCell}>{transaction.debit}</Text>
            <Text style={styles.tableCell}>{transaction.correct_current_balance}</Text>
          </View>
        ))}
        {/* Summary Row */}
        <View style={[styles.tableRow, styles.totalRow]}>
          <Text style={styles.tableCell}>Total</Text>
          <Text style={styles.doubleWidthCell}></Text> 
          <Text style={styles.doubleWidthCell}></Text>
          <Text style={styles.tableCell}>{summary.totalCredit}</Text>
          <Text style={styles.tableCell}>{summary.totalDebit}</Text>
          <Text style={styles.tableCell}>{summary.balance}</Text>
        </View>
      </View>
      <View style={styles.footer}>
      <Text style={styles.footerContent}>Served by: {agent?.surname} {agent?.other_names} </Text>
      <Text style={styles.footerContent}>Signature: ................... </Text>
      <Text style={styles.footerContent}>Date: {new Date().toLocaleString()} </Text>
      </View>

      
    </Page>
  </Document>
);

export default PDFViewer;